<template>
    <!-- 쳇봇 -->
    <div class="lang">
        <a href="javascript:;" class="chetbot cv" @click="chatbotOpen">
            <img src="@/assets/resource/img/main/chetbot2.gif" alt="" />
            <h3 class="chetbot-tit">CHATBOT</h3>
        </a>
        <!-- 쳇봇팝업 -->
        <div class="popup popup-chetbot" :class="{ active: popup_chetbot }">
            <div class="popup__inner">
                <div class="popup__tit">
                    <h2>Ewha Womans University Cerebrovascular Hospital way to find</h2>
                    <button type="button" class="popup__close" @click="popup_chetbot_active"><img src="@/assets/resource/icon/close.svg" alt="" /></button>
                </div>
                <div class="popup__body">
                    <div class="popup-chetbot__left">
                        <div class="popup-chetbot__left__top">
                            <div class="popup-chetbot__left__top__cont">
                                <h3 class="popup-chetbot__left--title">a place of departure</h3>
                                <div class="select">
                                    <a href="javascript:;" class="select--btn" :class="{ active: chetbot_select }" @click.prevent="activechetbot_select">{{ mapStartTxt }}</a>
                                    <slide-up-down :active="chetbot_select" class="select-option">
                                        <a href="javascript:;" class="select-option--btn" @click="[setMapList('B1'), activechetbot_select()]">Exit No. 8 of Balsan Station</a>
                                        <a href="javascript:;" class="select-option--btn" @click="[setMapList('main'), activechetbot_select()]">Hospital main entrance (main gate)</a>
                                        <a href="javascript:;" class="select-option--btn" @click="[setMapList('north'), activechetbot_select()]">Hospital sub-entrance (north gate)</a>
                                        <a href="javascript:;" class="select-option--btn" @click="[setMapList('parking'), activechetbot_select()]">Underground parking lot B3 to B5</a>
                                    </slide-up-down>
                                </div>
                            </div>
                            <div class="popup-chetbot__left__top__cont">
                                <h3 class="popup-chetbot__left--title">destination</h3>
                                <h4 class="title03">Ewha Womans University Cerebrovascular Hospital</h4>
                            </div>
                        </div>
                        <div class="popup-chetbot__left__bottom">
                            <div class="popup-chetbot__left__bottom__cont">
                                <p v-html="mapList[mapIndex].start"></p>
                                <span class="arrow"></span>
                                <p v-html="mapList[mapIndex].end"></p>
                            </div>
                            <div class="popup-chetbot__btn-wrap">
                                <a href="javascript:;" :class="{'popup-chetbot__btn': true, 'active': mapIndex == 1}" @click="mapIndex = 0">Prev  Path</a>
                                <a href="javascript:;" :class="{'popup-chetbot__btn': true, 'active': mapIndex == 0}" @click="mapIndex = 1">Next  Path</a>
                            </div>
                        </div>
                    </div>
                    <div class="popup-chetbot__right">
                        <div class="popup-chetbot__img">
                            <img :src="require(`@/assets/resource/img/main/${mapList[mapIndex].src}`)" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <section class="brain-sec brain-sec01">
                <div class="brain-sec01_scroll">
                    <img src="@/assets/resource/img/main/main_scroll.png" alt="" />
                </div>
                <div class="brain-kv__video">
                    <video src="@/assets/resource/video/cv_main_visual.mp4" class="mo-none" autoplay muted loop></video>
                    <!-- mo -->
                    <img src="@/assets/resource/img/brain-sec01.png" class="pc-none" alt="" />
                </div>

                <div class="lang brain-sec01__hide">
                    <div class="brain-sec01__hide-bg"></div>
                    <div class="txt">
                        <p class="txt__item txt__item1">a Guardian of Cerebrovascular Patients 24/7, 365 Days a Year</p>
                        <p class="txt__item txt__item2">Ewha Womans University<br> Cerebrovascular Hospital</p>
                    </div>
                    <div class="visual-main__con">
                        <ul class="visual-main__list">
                            <li class="visual-main__item">
                                <div class="visual-main__test">
                                    <h4>Online Appointment</h4>
                                    <p> You can make a reservation and check your reservation easy and quick on-line. </p>
                                </div>
                                <div class="visual-main__botton">
                                    <router-link to="/en/international/appointment" class="visual-main__buttom">Appointment</router-link>
                                </div>
                            </li>
                            <li class="visual-main__item">
                                <div class="visual-main__test">
                                    <h4>Location and Direction</h4>
                                    <p> How to get to and park at Hospital </p>
                                </div>
                                <div class="visual-main__botton">
                                    <div class="visual-main__buttom-wrap">
                                        <a href="javascript:;" class="visual-main__buttom" @click.prevent="popup_chetbot_active">Direction</a>
                                        <router-link to="/en/intro/parking" class="visual-main__buttom">Parking Information</router-link>
                                    </div>
                                </div>
                            </li>
                            <li class="visual-main__item">
                                <div class="visual-main__test">
                                    <h4>Treatment Guide</h4>
                                    <p> Contact Number </p>
                                    <p class="num">+82-2-6986-3100 <br> <span>(Contact Hours : 08:00 ~ 17:00)</span></p>
                                    <p>E-Mail : eumcint@gmail.com</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            <section class="brain-sec brain-sec02 top">
                <div class="brain__inner">
                    <p class="brain__sub-tit">Cerebrovascular</p>
                    <h2 class="brain__tit">‘Uniqueness of Ewha Womans University Cerebrovascular Hospital’</h2>
                    <div class="brain-sec02__wrap">
                        <ul class="brain-sec02__list">
                            <li class="brain-sec02__item item1">
                                <h3>
                                    Grade 1 in Appropriateness Evaluation of Acute Stroke Treatment
                                </h3>
                            </li>
                            <li class="brain-sec02__item item2">
                                <h3>
                                    Dedicated Ward of the Cerebrovascular Hospital
                                </h3>
                            </li>
                            <li class="brain-sec02__item item3">
                                <h3>
                                    24-hour Specialist Surgery and Craniotomy
                                </h3>
                            </li>
                            <li class="brain-sec02__item item4">
                                <h3>
                                    Single Rooms Available in the ICU
                                </h3>
                            </li>
                            <li class="brain-sec02__item item5">
                                <h3>
                                    Intensive Treatment in the Stroke Rehabilitation Center
                                </h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            <section class="brain-sec section02 brain-sec03">
                <ul class="section02__backgroundtext">
                    <li>
                        <img src="@/assets/resource/img/main/brain-sec03__backgroundtext1.png" alt="" />
                    </li>
                    <li>
                        <img src="@/assets/resource/img/main/brain-sec03__backgroundtext2.png" alt="" />
                    </li>
                </ul>
                <div class="inner">
                    <div class="section02__background">
                        <img class="section02__background-ball1" src="@/assets/resource/img/main/section02__background-ball.png" alt="" />
                        <img class="section02__background-ball2" src="@/assets/resource/img/main/section02__background-ball2.png" alt="" />
                        <img class="section02__background-ball3" src="@/assets/resource/img/main/section02__background-ball3.png" alt="" />
                        <span class="section02__background-smollball no1"></span>
                        <span class="section02__background-smollball no2"></span>
                        <span class="section02__background-smollball no3"></span>
                        <span class="section02__background-smollball no4"></span>
                        <span class="section02__background-smollball no5"></span>
                        <span class="section02__background-smollball no6"></span>
                    </div>

                    <div class="section02_top_title">
                        <h4>
                            Ewha Womans University Cerebrovascular Hospital, a Guardian of Cerebrovascular Patients 24/7, 365 Days a Year
                        </h4>
                    </div>

                    <!-- pc -->
                    <div class="brain-sec03__slide mo-none">
                        <div class="swiper section02-swiper">
                            <div class="section02__list transition02 swiper-wrapper">
                                <div :class="`section02__list--aa swiper-slide section02__list--item0${idx + 1}`" v-for="(doctor, idx) in doctorList" :key="idx">
                                    <a href="javascript:;" :class="`section02__list--item cursor doctor0${idx + 1}`" :data-drsid="doctor.drSid" :data-deptcd="doctor.mainDeptCd">
                                        <div class="section02__list--item--img">
                                            <img :src="`/displayFile.do?attachNo=${doctor.attachBag.thumbs[0].attachNo}`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor.attachBag.thumbs" />
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="section02-swiper-button-wrap">
                                <button class="section02-swiper-button-next"></button>
                                <button class="section02-swiper-button-prev"></button>
                            </div>
                        </div>
                        <div class="swiper section02-swiper2">
                            <div class="section02_bottom_title transition02 swiper-wrapper">
                                <div :class="{ 'swiper-slide': true, on: idx == 2 }" v-for="(doctor, idx) in doctorList" :key="idx">
                                    <h4>{{ doctor.drNameGlb }} professor</h4>
                                    <p>{{ doctor.detailField }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- mo -->
                <div class="pc-none">
                    <swiper :slidesPerView="1.3" :centeredSlides="true" :spaceBetween="30" :grabCursor="true" :navigation="{
                        nextEl: '.section02-swiper-button-next',
                        prevEl: '.section02-swiper-button-prev'
                    }" :modules="modules" class="swiper03">
                        <swiper-slide class="swiper03__slide" v-for="(doctor, idx) in doctorList" :key="idx">
                            <a href="javascript:;" :class="`section02__list--item cursor doctor0${idx + 1}`" :data-drsid="doctor.drSid" :data-deptcd="doctor.mainDeptCd">
                                <div class="section02__list--item--img">
                                    <img :src="`/displayFile.do?attachNo=${doctor.attachBag.thumbs[0].attachNo}`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor.attachBag.thumbs" />
                                </div>
                            </a>
                            <div class="swiper03__text">
                                <h4 class="tit">{{ doctor.drNameGlb }} Professor</h4>
                                <p class="desc">{{ doctor.detailField }}</p>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="section02-swiper-button-wrap">
                        <button class="section02-swiper-button-next"></button>
                        <button class="section02-swiper-button-prev"></button>
                    </div>
                </div>
            </section>

            <section class="brain-sec brain-sec04">
                <div class="bg-icon bg-icon01"><img src="@/assets/resource/img/sec04-box.png" alt="" /></div>
                <div class="btn-wrap mo-show">
                    <button type="button" class="swiper04-btn swiper04-prev"></button>
                    <button type="button" class="swiper04-btn swiper04-next"></button>
                </div>
                <div class="brain-sec04__img">
                    <div class="bg-icon bg-icon02"><img src="@/assets/resource/img/sec04-box.png" alt="" /></div>
                    <swiper :spaceBetween="30" :effect="'fade'" :navigation="{
                        nextEl: '.swiper04-next',
                        prevEl: '.swiper04-prev'
                    }" :loop="true" :modules="modules" class="swiper04" @slideChangeTransitionStart="onSlideChange">
                        <swiper-slide class="swiper04-slide slide1">
                            <div class="swiper04-slide__inner">
                                <p class="swiper04-slide__text">
                                    Ischemic <br />
                                    Storoke <br />
                                    Center
                                </p>
                                <div class="img">
                                    <img src="@/assets/resource/img/sec04-slide01.png" alt="" />
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide class="swiper04-slide slide2">
                            <div class="swiper04-slide__inner">
                                <p class="swiper04-slide__text">
                                    Hemorrhagic <br />
                                    Storoke <br />
                                    Center
                                </p>
                                <div class="img">
                                    <img src="@/assets/resource/img/sec04-slide02.png" alt="" />
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide class="swiper04-slide slide3">
                            <div class="swiper04-slide__inner">
                                <p class="swiper04-slide__text">
                                    Stereotactic <br />
                                    Radiosurgery <br />
                                    Center
                                </p>
                                <div class="img">
                                    <img src="@/assets/resource/img/sec04-slide03.png" alt="" />
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide class="swiper04-slide slide4">
                            <div class="swiper04-slide__inner">
                                <p class="swiper04-slide__text">
                                    Stroke <br />
                                    Rehabilitation <br />
                                    Center
                                </p>
                                <div class="img">
                                    <img src="@/assets/resource/img/sec04-slide04.png" alt="" />
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>

                <div class="brain-sec04__text">
                    <div class="line-box">
                        <div class="line"></div>
                        <p>Best center</p>
                    </div>
                    <div class="btn-wrap">
                        <button type="button" class="swiper04-btn swiper04-prev"></button>
                        <button type="button" class="swiper04-btn swiper04-next"></button>
                    </div>
                    <ul class="brain-sec04__list swiper04-txt">
                        <li class="brain-sec04__item text1 show">
                            <div class="top">
                                <p class="brain__sub-tit">Cerebrovascular</p>
                                <h2 class="brain__tit">Ischemic Storoke Center</h2>
                                <p class="brain__desc">
                                    The Cerebral Infarction Center of the Ewha Cerebrovascular Hospital aims to provide comprehensive medical care encompassing diagnosis, treatment, and prevention for patients who suffer from acute or chronic cerebral infarction.
                                </p>
                            </div>
                            <div class="bottom">
                                <a href="/en/center?deptCd=ST1" class="more">
                                    View more
                                    <div class="icon">
                                        <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                        <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                    </div>
                                </a>
                            </div>
                        </li>
                        <li class="brain-sec04__item text2">
                            <div class="top">
                                <p class="brain__sub-tit">Cerebrovascular</p>
                                <h2 class="brain__tit">Hemorrhagic Storoke Center</h2>
                                <p class="brain__desc">
                                    The Cerebral Hemorrhage Center of the Ewha Cerebrovascular Hospital provides prevention, diagnosis, and treatment for a broad range of hemorrhagic cerebrovascular diseases.
                                </p>
                            </div>
                            <div class="bottom">
                                <a href="/en/center?deptCd=ST2" class="more">
                                    View more
                                    <div class="icon">
                                        <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                        <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                    </div>
                                </a>
                            </div>
                        </li>
                        <li class="brain-sec04__item text3">
                            <div class="top">
                                <p class="brain__sub-tit">Cerebrovascular</p>
                                <h2 class="brain__tit">Stereotactic Radiosurgery Center</h2>
                                <p class="brain__desc">
                                    The Stereotactic Radiation Therapy Center of the Ewha Seoul Hospital performs precision radiosurgery using TrueBeam's HyperArc solution, a state-of-the-art radiotherapy equipment. HyperArc is a radiosurgery system that uses a 2.5mm wide multi-leaf collimator and a 6DoF couch to perform precise radiosurgery at the location of a lesion while minimizing the impact of radiation on normal brain tissue.
                                </p>
                            </div>
                            <div class="bottom">
                                <a href="/en/center?deptCd=BRC" class="more">
                                    View more
                                    <div class="icon">
                                        <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                        <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                    </div>
                                </a>
                            </div>
                        </li>
                        <li class="brain-sec04__item text4">
                            <div class="top">
                                <p class="brain__sub-tit">Cerebrovascular</p>
                                <h2 class="brain__tit">Stroke Rehabilitation Center</h2>
                                <p class="brain__desc">The Stroke Rehabilitation Center provides treatment for physical paralysis, cognitive decline, and difficulty in swallowing that often occur after a stroke or brain damage.</p>
                            </div>
                            <div class="bottom">
                                <a href="/en/center?deptCd=SRHC" class="more">
                                    View more
                                    <div class="icon">
                                        <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                        <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                    </div>
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>

            <section class="section section05">
                <div class="section__title">
                    <h3>Promotional video</h3>
                </div>
                <div class="video">
                    <div class="inner brain__inner">
                        <div class="video__visual">
                            <iframe src="https://www.youtube.com/embed/5yiBJjfOyxE" title="World Best, Ewha Womans University Aorta and Vascular Hospital" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <ul class="video__list">
                            <li class="video__item">
                                <a href="/en/international/Introduction" class="video__link">
                                    <span class="box">
                                        <span class="icon">
                                            <img src="/resource/icon/video_list_icon1--brain.png" alt="">
                                        </span>
                                        <span class="text">International Treatment
                                            Guide</span>
                                    </span>
                                    <span class="arrow"></span>
                                </a>
                            </li>
                            <li class="video__item">
                                <a href="/en/international/reservation" class="video__link">
                                    <span class="box">
                                        <span class="icon">
                                            <img src="/resource/icon/video_list_icon2--brain.png" alt="">
                                        </span>
                                        <span class="text">Reservation Guide</span>
                                    </span>
                                    <span class="arrow"></span>
                                </a>
                            </li>
                            <li class="video__item">
                                <a href="/en/international/office" class="video__link">
                                    <span class="box">
                                        <span class="icon">
                                            <img src="/resource/icon/video_list_icon3--brain.png" alt="">
                                        </span>
                                        <span class="text">Office Hours</span>
                                    </span>
                                    <span class="arrow"></span>
                                </a>
                            </li>
                            <li class="video__item">
                                <a href="/en/international/staff" class="video__link">
                                    <span class="box">
                                        <span class="icon">
                                            <img src="/resource/icon/video_list_icon4--brain.png" alt="">
                                        </span>
                                        <span class="text">Staff</span>
                                    </span>
                                    <span class="arrow"></span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            <div class="footer__center-wrap type2">
                <div class="footer__center-list">
                    <ul>
                        <li class="footer__center-item">
                            <a href="javascript:;" class="footer__center-link"><span class="name">EWHA FAMILLY</span></a>
                        </li>
                        <li class="footer__center-item">
                            <a href="https://www.eumc.ac.kr/main.do" class="footer__center-link" target="_blank"> <span class="name">의료원</span></a>
                        </li>
                        <li class="footer__center-item">
                            <a href="https://mokdong.eumc.ac.kr/main.do" class="footer__center-link" target="_blank"> <span class="name">이대목동병원</span></a>
                        </li>
                        <li class="footer__center-item">
                            <a href="https://seoul.eumc.ac.kr/main.do" class="footer__center-link" target="_blank"> <span class="name">이대서울병원</span></a>
                        </li>
                        <li class="footer__center-item">
                            <div class="effect-icon"></div>
                            <a href="https://part.eumc.ac.kr/dept/pogoonyogoan/index.do" class="footer__center-link" target="_blank">
                                <span class="name"><img src="@/assets/resource/img/main/bogu_logo.png" alt="" style="margin-right: 5px" />보구녀관</span></a>
                        </li>

                        <li class="footer__center-item">
                            <a href="http://aorta.eumc.ac.kr" class="footer__center-link" target="_blank"> <span class="name">이대대동맥병원</span></a>
                        </li>
                        <li class="footer__center-item">
                            <a href="http://ewhabrain.eumc.ac.kr" class="footer__center-link" target="_blank"> <span class="name">이대뇌혈관병원</span></a>
                        </li>
                        <li class="footer__center-item">
                            <a href="http://mombaby.eumc.ac.kr" class="footer__center-link" target="_blank"> <span class="name">이대엄마아기병원</span></a>
                        </li>
                        <li class="footer__center-item">
                            <a href="https://wch.eumc.ac.kr/main.do" class="footer__center-link" target="_blank"> <span class="name">이대여성암병원</span></a>
                        </li>
                        <li class="footer__center-item">
                            <a href="https://ewui.eumc.ac.kr/main.do" class="footer__center-link" target="_blank"> <span class="name">이대비뇨기병원</span></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <kr_FirstReserveInputPopUp :popupVisible="firstVisible" @hide-popup="hidePopup" />
    <kr_AlarmTalkInputPopup :popupVisible="alarmVisible" @hide-popup="hidePopup" />
</template>
<script>
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import { FreeMode, Pagination, Navigation, Thumbs, EffectFade } from 'swiper/modules'; // EffectFade 추가
    import 'swiper/css';
    import 'swiper/css/free-mode';
    import 'swiper/css/effect-fade';
    import 'swiper/css/navigation';
    import 'swiper/css/thumbs';
    import SlideUpDown from 'vue-slide-up-down';

    import { gsap, Power1 } from 'gsap';
    import ScrollTrigger from 'gsap/ScrollTrigger';
    gsap.registerPlugin(ScrollTrigger);

    export default {
        components: {
            SlideUpDown,
            Swiper,
            SwiperSlide
        },
        data() {
            return {
                firstVisible: false,
                alarmVisible: false,
                sec01Tab: false,
                slideNum: '',
                chetbot_select: false,
                popup_chetbot: false,
                mapList: [
                    { src: `map_B1_${this.$store.getters.getLang}02.png`, start: 'Exit No. 8 of Balsan Station', end: 'Elevators and escalators for outpatients only' },
                    { src: `map_3F_${this.$store.getters.getLang}02.png`, start: 'Get off on the 3rd floor', end: 'Left of the elevator <br> Ewha Womans University Aorta and Vascular Hospital ' }
                ],
                mapIndex: 0,
                doctorList: [],
                mapStartTxt: 'Exit No. 8 of Balsan Station',
                drSids: '1004540,1005101,1012649,1019621,1019623,1019794',

                noticeBoardId: '',
                noticeList: [],
                tvList: [],
                storyList: [],
            };
        },
        setup() {
            return {
                modules: [EffectFade, Navigation, Pagination]
            };
        },
        methods: {
            showPopup(param) {
                this[param] = true;
                console.log(param);
                console.log(this[param]);
            },
            hidePopup(param) {
                this[param] = false;
            },
            getMainBoardList() {
                const param = {
                    pageRow: 6
                }
                this.axios.get(this.api.article.main, {
                    params: param
                })
                    .then(res => {
                        const list = res.data
                        if (list) {
                            const hostName = this.$store.getters.getHostName;
                            let prefix = 'aorta'
                            if (hostName == 'ewhabrain') {
                                prefix = 'vie';
                            } else if (hostName == 'mombaby') {
                                prefix = 'vie';
                            }
                            this.noticeBoardId = list['notice'].length > 0 ? list['notice'][0].boardId : `${prefix}_notice`
                            if (list['notice']) {
                                const len = list['notice'].length
                                this.noticeList = list['notice'].slice(Math.min(len, 3))
                            }
                            this.tvList = list['tv']
                            this.storyList = list['story']
                        }

                        // Swiper 초기화
                        // this.nextTick(() => {
                        //     this.boardSwipers();
                        // });
                    })
            },
            onSlideChange(swiper) {
                const activeSlide = document.querySelector('.brain-sec04 .swiper-slide-active');
                if (activeSlide && activeSlide.classList.contains('slide1')) {
                    // slide1에 해당하는 active slide가 있을 때 실행할 코드
                    document.querySelector('.text1').classList.add('show');
                } else {
                    document.querySelector('.text1').classList.remove('show');
                }
                if (activeSlide && activeSlide.classList.contains('slide2')) {
                    document.querySelector('.text2').classList.add('show');
                } else {
                    document.querySelector('.text2').classList.remove('show');
                }
                if (activeSlide && activeSlide.classList.contains('slide3')) {
                    document.querySelector('.text3').classList.add('show');
                } else {
                    document.querySelector('.text3').classList.remove('show');
                }
                if (activeSlide && activeSlide.classList.contains('slide4')) {
                    document.querySelector('.text4').classList.add('show');
                } else {
                    document.querySelector('.text4').classList.remove('show');
                }
            },
            chatbotOpen() {
                const w = 450;
                const h = 550;
                let xPos = document.body.offsetWidth / 2 - w / 2;
                xPos += window.screenLeft; // 듀얼 모니터일 때
                const yPos = document.body.offsetHeight / 2 - h / 2;

                window.open('https://pf.kakao.com/_xdvyYT/chat?bot=true', 'chatbot', `width=${w}, height=${h}, left=${xPos}, top=${yPos}, menubar=yes, status=yes, titlebar=yes, resizable=yes`);
            },
            setMapList(start) {
                this.mapIndex = 0;
                this.mapList = [];
                if (start == 'B1') {
                    this.mapStartTxt = 'Exit No. 8 of Balsan Station';
                    const obj = { src: `map_B1_${this.$store.getters.getLang}02.png`, start: 'Exit No. 8 of Balsan Station', end: 'Elevators and escalators for outpatients only' };
                    this.mapList.push(obj);
                } else if (start == 'main') {
                    this.mapStartTxt = 'Hospital main entrance (main gate)';
                    const obj = { src: `map_1F_maingate_${this.$store.getters.getLang}02.png`, start: 'Hospital main entrance (main gate)', end: 'Elevators and escalators for outpatients only' };
                    this.mapList.push(obj);
                } else if (start == 'north') {
                    this.mapStartTxt = 'Hospital sub-entrance (north gate)';
                    const obj = { src: `map_1F_northgate_${this.$store.getters.getLang}02.png`, start: 'Hospital sub-entrance (north gate)', end: 'Elevators and escalators for outpatients only' };
                    this.mapList.push(obj);
                } else if (start == 'parking') {
                    this.mapStartTxt = 'Underground parking lot B3 to B5';
                    const obj = { src: `map_parkingGarage_${this.$store.getters.getLang}02.png`, start: 'Underground parking lot B3 to B5', end: 'Elevators and escalators for outpatients only<br>((Parking location: F, G, H, I))' };
                    this.mapList.push(obj);
                }
                const obj = { src: `map_3F_${this.$store.getters.getLang}02.png`, start: 'Get off on the 3rd floor', end: 'Left of the elevator<br>Ewha Womans University Aorta and Vascular Hospital ' };
                this.mapList.push(obj);
            },
            popup_chetbot_active() {
                this.popup_chetbot = !this.popup_chetbot;
            },
            activechetbot_select() {
                this.chetbot_select = !this.chetbot_select;
            },
            getDoctorList() {
                const drSids = "1004945,1012320,1012323,1015056,1017749"

                const langCd = this.$store.getters.getLang;
                const param = {
                    startIndex: 1,
                    drSids: drSids,
                    pageRow: 100,
                    langCd: langCd,
                    hospId: this.$store.getters.getHost,
                    // drSids: this.drSids
                };
                this.axios.get(this.api.doctor.doctorList, { params: param }).then(res => {
                    const arr = res.data.doctorList;
                    const doctorListTemp = this.$commonUtils.distinctList(arr, 'name');

                    //doctorList의 name이 송태진, 박무석, 조동영, 양서연, 박영희 순으로 정렬
                    for (let i = 0; i < doctorListTemp.length; i++) {
                        if (doctorListTemp[i].name == '박무석') {
                            this.doctorList[0] = doctorListTemp[i];
                        } else if (doctorListTemp[i].name == '송태진') {
                            this.doctorList[1] = doctorListTemp[i];
                        } else if (doctorListTemp[i].name == '조동영') {
                            this.doctorList[2] = doctorListTemp[i];
                        } else if (doctorListTemp[i].name == '양서연') {
                            this.doctorList[3] = doctorListTemp[i];
                        } else if (doctorListTemp[i].name == '박영희') {
                            this.doctorList[4] = doctorListTemp[i];
                        }
                    }




                    if (arr && arr.length > 0) {
                        const item = this.doctorList[2];
                        this.doctorList[2] = this.doctorList[1];
                        this.doctorList[1] = item;
                    }

                    this.$nextTick(() => {
                        // 의료진 소개 이벤트
                        $('.section02__list .section02__list--aa .section02__list--item').click(function (event) {
                            event.preventDefault(); // 링크의 기본 동작 방지
                            var index = $(this).parent().index(); // 클릭한 링크의 부모 div 요소의 인덱스 가져오기
                            $('.section02_bottom_title div').removeClass('on'); // 모든 p 요소에서 'on' 클래스 제거
                            $('.section02_bottom_title div').eq(index).addClass('on'); // 해당 인덱스에 맞는 p 요소에 'on' 클래스 추가
                        });
                        $('.section02__list a').click(function () {
                            var classes = $(this).attr('class').split(' ');
                            if (!$(this).hasClass('doctor03')) {
                                $('.doctor03').addClass(classes);
                                $('.doctor03').removeClass('doctor03');
                                $(this).removeClass(classes);
                                $(this).addClass('doctor03 cursor section02__list--item');
                            } else {
                                const drSid = $(this).data('drsid');
                                const deptCd = $(this).data('deptcd');
                                window.open(`/${langCd}/doctorInfo?drSid=${drSid}&deptCd=${deptCd}`, '_blank')
                            }
                        });
                    });
                });
            },
            gsapFn() {
                if (window.innerWidth >= 1024) {
                    // 신규
                    gsap.to('.brain-sec01', { scrollTrigger: { trigger: '.brain-sec01', start: '-88px top', end: '1800px', pin: true, } });

                    const tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: 'body',
                            start: 'top top',
                            end: '1500px',
                            scrub: 3,
                        }
                    });

                    tl.to('.brain-sec01', { height: 'calc(100vh)', maxHeight: 'calc(100vh)' }, 0)
                        .to('.brain-kv__video', { padding: 0 }, 0)
                        .from('.brain-sec01__hide', { opacity: 0 })
                        .from('.txt__item2', { scale: 0.5, opacity: 0 })
                        .from('.brain-sec01__hide-bg', { opacity: 0 }, '<')
                        .from('.txt__item1', { opacity: 0 })
                        .from('.visual-main__con', { height: '0' });

                    // sec1
                    gsap.to('.brain-sec03', { scrollTrigger: { trigger: '.brain-sec03', start: 'top center', scrub: 4, toggleClass: { targets: '.brain-sec03', className: 'on' } } });
                    gsap.from('.brain-kv__video', { padding: 0, delay: 2, duration: 1.2 });
                    // gsap.from('.brain-sec01__tab', { bottom: -160, delay: 5, duration: 0.5 });

                    gsap.from('.brain-sec01_scroll', { opacity: 0, y: -50, delay: 3, duration: 1.5 });
                    gsap.from('.chetbot.cv', { opacity: 0, y: -50, delay: 3, duration: 1.5 });
                    setTimeout(() => { this.sec01Tab = true; }, 4000);

                    // sec2
                    gsap.from('.brain-sec02 .brain__sub-tit', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 1, y: 50, opacity: 0 });
                    gsap.from('.brain-sec02 .brain__tit', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 1, delay: 0.5, y: 50, opacity: 0 });

                    // 1
                    // gsap.from('.brain-sec02 .brain-sec02__item', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: .6, y: 100, opacity: 0, stagger: 0.3 });

                    // 2
                    gsap.to('.brain .footer__center-list', { scrollTrigger: { trigger: '.footer', start: 'top bottom', scrub: true, toggleClass: { targets: '.footer__center-list', className: 'on' } } });

                    gsap.from('.brain-sec02 .brain-sec02__item.item1', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 60%' }, duration: 1.5, x: 200 + '%', stagger: 0.3, ease: 'Power1.easeOut' });
                    gsap.from('.brain-sec02 .brain-sec02__item.item2', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 60%' }, duration: 1.5, x: 100 + '%', stagger: 0.3, ease: 'Power1.easeOut' });
                    gsap.from('.brain-sec02 .brain-sec02__item.item3', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 60%' }, duration: 1.5, stagger: 0.3, ease: 'Power1.easeOut' });
                    gsap.from('.brain-sec02 .brain-sec02__item.item4', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 60%' }, duration: 1.5, x: -100 + '%', stagger: 0.3, ease: 'Power1.easeOut' });
                    gsap.from('.brain-sec02 .brain-sec02__item.item5', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 60%' }, duration: 1.5, x: -200 + '%', stagger: 0.3, ease: 'Power1.easeOut' });

                    // 3
                    // gsap.from('.brain-sec02 .brain-sec02__item.item1', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, y: -200, opacity: 0, stagger: 0.3 });
                    // gsap.from('.brain-sec02 .brain-sec02__item.item2', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, y: -100, opacity: 0, stagger: 0.3 });
                    // gsap.from('.brain-sec02 .brain-sec02__item.item3', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, opacity: 0, stagger: 0.3 });
                    // gsap.from('.brain-sec02 .brain-sec02__item.item4', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, y: 100, opacity: 0, stagger: 0.3 });
                    // gsap.from('.brain-sec02 .brain-sec02__item.item5', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, y: 200, opacity: 0, stagger: 0.3 });

                    // 4
                    // gsap.from('.brain-sec02 .brain-sec02__item.item1', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, x: -200, stagger: 0.3 });
                    // gsap.from('.brain-sec02 .brain-sec02__item.item2', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, x: -100, stagger: 0.3 });
                    // gsap.from('.brain-sec02 .brain-sec02__item.item3', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, stagger: 0.3 });
                    // gsap.from('.brain-sec02 .brain-sec02__item.item4', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, x: 100, stagger: 0.3 });
                    // gsap.from('.brain-sec02 .brain-sec02__item.item5', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, x: 200, stagger: 0.3 });

                    // sec4
                    gsap.from('.brain-sec04 .bg-icon01', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1.2, scale: 0, opacity: 0 });
                    gsap.from('.brain-sec04 .bg-icon02', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1.5, delay: 0.3, scale: 0, opacity: 0 });
                    gsap.from('.brain-sec04 .brain-sec04__item .top', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1.4, x: 100, opacity: 0 });
                    gsap.from('.brain-sec04 .btn-wrap', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1, delay: 0.3, x: 100, opacity: 0 });
                    gsap.from('.brain-sec04 .bottom', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1, delay: 0.5, x: 100, opacity: 0 });
                    gsap.from('.brain-sec04 .brain-sec04__text .line', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1.2, delay: 1.1, height: 0 });
                    gsap.from('.brain-sec04 .brain-sec04__text .line + p', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1, delay: 1, opacity: 0 });
                    gsap.from('.brain-sec04 .swiper04', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1.5, y: 100, opacity: 0 });

                    // sec5
                    gsap.from('.box1 .brain-sec05__text', { scrollTrigger: { trigger: '.brain-sec05', start: 'top 60%' }, duration: 0.7, x: 200, opacity: 0 });
                    gsap.from('.box1 .brain-sec05__slide', { scrollTrigger: { trigger: '.brain-sec05', start: 'top 60%' }, duration: 1, x: 300, opacity: 0 });

                    gsap.from('.box2 .brain-sec05__text', { scrollTrigger: { trigger: '.brain-sec05 .box2', start: 'top 60%' }, duration: 0.7, x: -200, opacity: 0 });
                    gsap.from('.box2 .brain-sec05__slide', { scrollTrigger: { trigger: '.brain-sec05 .box2', start: 'top 60%' }, duration: 1, x: -300, opacity: 0 });

                    // sec6
                    gsap.from('.brain-sec06 .brain__sub-tit', { scrollTrigger: { trigger: '.brain-sec06', start: 'top 70%' }, duration: 1, y: 50, opacity: 0 });
                    gsap.from('.brain-sec06 .brain__tit', { scrollTrigger: { trigger: '.brain-sec06', start: 'top 70%' }, duration: 1, delay: 0.5, y: 50, opacity: 0 });
                    gsap.from('.brain-sec06 .bottom', { scrollTrigger: { trigger: '.brain-sec06', start: 'top 70%' }, duration: 1, delay: 0.7, y: 30, opacity: 0 });
                    gsap.from('.brain-sec06 .brain-sec06__item', { scrollTrigger: { trigger: '.brain-sec06', start: 'top 70%' }, duration: 1, x: 100, delay: 0.5, opacity: 0, stagger: 0.3 });

                    // 의료진 소개
                    gsap.from('.section02_top_title', { scrollTrigger: { trigger: '.section02_top_title', start: 'top center' }, duration: 1, y: 100, opacity: 0 });

                    // Promotional video
                    gsap.from('.section05 .section__title', { scrollTrigger: { trigger: '.section05', start: 'top center' }, duration: 1, y: 100, opacity: 0 });
                    gsap.from('.section05 .video', { scrollTrigger: { trigger: '.section05', start: 'top center' }, duration: 1, delay: .3, y: 100, opacity: 0 });
                } else {
                }
            }
        },
        mounted() {
            // this.getMainBoardList()
            this.getDoctorList();
            this.gsapFn();

            gsap.to('.brain .footer__center-list', { scrollTrigger: { trigger: '.brain-sec02', start: 'top bottom', end: '-200%', scrub: true }, bottom: '0' });
            gsap.to('.chetbot', { scrollTrigger: { trigger: '.brain-sec02', start: 'top bottom', end: '-200%', scrub: 2 }, top: 80 });

        }
    };
</script>